import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import { ConnectionStatus } from '../slices/signalRSlice';

export const selectConnectionStatus = createSelector(
  [(state: RootState) => state.signalR.connectionStatus],
  status => status
);

export const selectConnectionError = createSelector(
  [(state: RootState) => state.signalR.error],
  error => error
);

export const selectIsConnected = createSelector(
  [(state: RootState) => state.signalR.connectionStatus],
  status => status === ConnectionStatus.IsConnected
);

export const selectIsConnecting = createSelector(
  [(state: RootState) => state.signalR.connectionStatus],
  status => status === ConnectionStatus.IsConnecting
);

export const selectIsConnectionUninitialized = createSelector(
  [(state: RootState) => state.signalR.connectionStatus],
  status => status === ConnectionStatus.Uninitialized
);

export const selectIsConnectionFailed = createSelector(
  [(state: RootState) => state.signalR.connectionStatus],
  status => status === ConnectionStatus.ConnectionFailed
);

export const selectIsRequestStart = createSelector(
  [(state: RootState) => state.signalR.requestStart],
  requestStart => requestStart === true
);
